import {
  assertBlockedStatus,
  assertChatNotFoundStatus,
  assertForbiddenTextStatus,
  assertNeedCaptchaStatus,
  assertNeedConfirmPhoneStatus,
  assertOfferNotFoundStatus,
  assertSuccessStatus,
  assertUnknownErrorStatus,
  assertUserCanNotChatWithHimselfStatus,
  assertUserCanNotChatWithHisColleaguesStatus,
  assertUserChatsDisabledStatus,
  assertUserNotFoundStatus,
  assertUserSendingDisabledStatus,
  assertValidationErrorStatus,
  assertWrongCaptchaTokenStatus,
} from '../../assertions';

export const assertions = [
  assertSuccessStatus,
  assertBlockedStatus,
  assertForbiddenTextStatus,
  assertNeedCaptchaStatus,
  assertNeedConfirmPhoneStatus,
  assertUserChatsDisabledStatus,
  assertValidationErrorStatus,
  assertUserSendingDisabledStatus,
  assertOfferNotFoundStatus,
  assertUserNotFoundStatus,
  assertUserCanNotChatWithHimselfStatus,
  assertUserCanNotChatWithHisColleaguesStatus,
  assertWrongCaptchaTokenStatus,
  assertChatNotFoundStatus,
  assertUnknownErrorStatus,
];
